export default __webpack_public_path__ + "static/media/lgn-laptop-side.ad34e92f.webp";